<div class="scrollbar" [style.visibility]="visibility" #scrollbar>
  <div class="scrollbar-thumb" #scrollbarThumb></div>
</div>
